import { forwardRef } from 'react';

import { FieldLabel, FieldLabelElement, FieldLabelProps } from './FieldLabel.js';
import { useFieldContext } from './useFieldContext.js';

export type FieldHelperTextElement = FieldLabelElement;

export interface FieldHelperTextProps extends FieldLabelProps {}

/**
 * Is a component intended to be used as a label for a form field.
 */
export const FieldHelperText = forwardRef<FieldHelperTextElement, FieldHelperTextProps>(
  ({ children, ...restProps }, ref) => {
    const { helpText = children } = useFieldContext();
    return (
      <FieldLabel ref={ref} variant="label" {...restProps}>
        {helpText}
      </FieldLabel>
    );
  }
);
